class ModalWindow extends HTMLElement {
  constructor() {
    super();
    this.$closeButtons = this.querySelectorAll('[data-close]');
    this.rememberClose = this.dataset.rememberClose !== undefined ? true : false;
    this.openDefault = this.dataset.openDefault !== undefined ? true : false;
  }

  connectedCallback() {
    if (this.rememberClose && !this.id) {
      console.error('ModalWindow must have an id attribute');
      return;
    }

    this.init();
  }

  init() {
    if (this.openDefault) {
      this.open();
    }

    this.$closeButtons.forEach(element => {
      element.addEventListener('click', () => {
        this.close();
      });
    });
  }

  open() {
    if (this.rememberClose && this.id) {
      if (localStorage.getItem(`modal-${this.id}`) === 'closed') {
        return;
      }
    }
    this.hidden = false;
  }

  close() {
    this.hidden = true;
    if (this.rememberClose && this.id) {
      localStorage.setItem(`modal-${this.id}`, 'closed');
    }
  }
}

customElements.define('modal-window', ModalWindow);
